import styled from "styled-components";

export const TeamCardHolderDiv = styled.div`
  max-width: var(--width);
  margin: 0 auto;
  padding: 0;
  /* padding: var(--insidePadding); */
  display: flex;
  justify-content: center;
  position: relative;
  /* background-color: var(--background); */
  & .my-masonry-grid {
    display: -webkit-box; /* Not needed if autoprefixing */
    display: -ms-flexbox; /* Not needed if autoprefixing */
    display: flex;
    margin-left: -20px; /* gutter size offset */
    width: auto;
  }
  & .my-masonry-grid_column {
    padding-left: 20px; /* gutter size */
    background-clip: padding-box;
    width: 315px !important;
    &:nth-child(1),
    &:nth-child(4) {
      margin-top: 75px;
    }
    &:nth-child(3),
    &:nth-child(6) {
      margin-top: 150px;
    }
  }

  & .my-masonry-grid_column > div {
    margin-bottom: 20px;
  }
`;

export const TeamCard = styled.div`
  width: 295px;
  margin-bottom: 12px;
  & h5 {
    margin: 0;
    &:first-of-type {
      margin-top: 8px;
    }
  }
  & > a {
    color: var(--black);
    > div {
      /* background-color: var(--red);
      width: 100%;
      min-height: 400px; */
    }
    > img {
      width: 100%;
      height: auto;
    }
  }
`;

export const OverlayDiv = styled.div`
  position: fixed;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);  
  width: 1340px;
  z-index: 9999;
  & > div:first-child {
    background-color: var(--white);
    padding: 84px 50px 50px 50px;
    border-top: 4px solid var(--green);
    display: flex;
    
    & + div {
      margin-left: 0;
      max-width: 1340px;
      z-index: 9;
      margin-bottom: 0;
      min-height: auto;
      padding: 25px 0; 
    }
    & > div:first-of-type {
      width: 295px;
      & > img {
        width: 100%;
        height: auto;
      }
      & h4 {
        margin-top: 35px;
        padding-top: 8px;
        color: var(--green);
        border-top: 4px solid var(--green);
      }
      & p {
        font-size: 18px;
        font-weight: 400;
        line-height: 25.2px;
        margin: 0;
        & + svg {
          margin-top: 18px;
        }
      }
      & + div {
        margin-left: 25px;
        width: 802px;
        & h3:first-of-type {
          color: var(--green);
          & + h3 {
            margin-bottom: 30px;
          }
        }
        & p {
          margin: 0;
          font-weight: 400;
          font-size: 18px;
          line-height: 25.2px;
          & + p {
            margin-top: 1em;
          }
        }
        & div strong {
          color: var(--green);
        }
      }
    }
  }
  & > svg {
    position: absolute;
    top: 29px;
    right: 37px;
    cursor: pointer;
  }
  @media only screen and (max-width:1500px){
    & > div:first-child {
      padding: 30px 50px 30px;
    }
    }
  @media only screen and (max-width:767px){
    & > div:first-child {
      display: block;
      padding: 20px;
      & > div:first-of-type{
        & + div{
          margin: 15px 0;
          width: auto;
        }
      }
    }
    
    }
  @media only screen and (max-width:767px)
  {
    width: 90%;
    top: 10%;
    height: 500px;
    transform: none;
    overflow-x: auto; 
  }
`;

export const Scrim = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.125);
  /* background: #f1f2ef; */
  background-blend-mode: multiply;
  transition: 0.5s;
`;
